import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NgxSkeletonLoaderComponent } from 'ngx-skeleton-loader';

@Component({
  selector: 'app-skeleton-modal-product-inquiry-via-exhibitor',
  imports: [NgxSkeletonLoaderComponent],
  templateUrl: './skeleton-modal-product-inquiry-via-exhibitor.component.html',
  styleUrl: './skeleton-modal-product-inquiry-via-exhibitor.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SkeletonModalProductInquiryViaExhibitorComponent {}
